var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48AEE2"
    },
    d: "M280.625,476.297H156.021c-32.995,0-59.839-26.844-59.839-59.839V256.005 c0-26.357,39.893-26.385,39.893,0v160.453c0,10.998,8.948,19.946,19.946,19.946h124.604c10.998,0,19.946-8.948,19.946-19.946 V284.811c0-32.995,26.844-59.839,59.839-59.839h19.942c26.357,0,26.385,39.893,0,39.893h-19.942c-11,0-19.946,8.948-19.946,19.946 v131.647C340.465,449.453,313.622,476.297,280.625,476.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39A3DB"
    },
    d: "M380.353,224.972h-19.942c-32.997,0-59.839,26.844-59.839,59.839v131.647 c0,10.997-8.948,19.946-19.946,19.946h-24.626v39.893h24.626c32.995,0,59.839-26.845,59.839-59.839V284.811 c0-10.998,8.947-19.946,19.946-19.946h19.942C406.711,264.865,406.739,224.972,380.353,224.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3797D3"
    },
    d: "M436.204,320.711c-41.794,0-75.797-34.002-75.797-75.797s34.002-75.796,75.797-75.796 S512,203.12,512,244.914S477.998,320.711,436.204,320.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39A3DB"
    },
    d: "M470.773,244.914c0,19.091-15.477,34.57-34.57,34.57c-19.091,0-34.569-15.477-34.569-34.57 C401.635,199.233,470.773,199.187,470.773,244.914z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939598"
    },
    d: "M0,114.159v-58.51c0-11.016,8.931-19.946,19.946-19.946h40.779c11.016,0,19.946,8.931,19.946,19.946 s-8.931,19.946-19.946,19.946H39.893v38.563C39.893,140.516,0,140.543,0,114.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939598"
    },
    d: "M212.318,134.105c-11.016,0-19.946-8.931-19.946-19.946V75.596h-20.832 c-11.016,0-19.946-8.931-19.946-19.946s8.931-19.946,19.946-19.946h40.779c11.016,0,19.946,8.931,19.946,19.946v58.51 C232.264,125.175,223.334,134.105,212.318,134.105z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D0E1"
    },
    d: "M0,159.823v-45.664c0-11.016,8.931-19.946,19.946-19.946h66.488c11.016,0,19.946,8.931,19.946,19.946 v45.664c0,12.885,19.508,12.881,19.508,0v-45.664c0-11.016,8.931-19.946,19.946-19.946h66.488c11.016,0,19.946,8.931,19.946,19.946 v45.664c0,31.018-12.082,60.182-34.021,82.122C125.613,314.526,0,263.338,0,159.823z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.b254391070490d4e7a51c85579fa0a23.svg";
export { ForwardRef as ReactComponent };